import { Component, Input, ViewChild } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

import {
  FromScratchFormComponent,
  FromScratchFormResult,
} from "./from-scratch-form/from-scratch-form.component";
import {
  FromDocumentFormComponent,
  FromDocumentFormResult,
} from "./from-document-form/from-document-form.component";
import { TranslocoService } from "@jsverse/transloco";

export interface IGenerationService {
  generateFromDocument(
    file: File,
    prompt: string,
    option: { name: string; value: string },
  ): void;

  generateFromScratch(
    prompt: string,
    option: { name: string; value: string },
  ): void;
}

@Component({
  selector: "app-generate-from-document-or-prompt-modal",
  templateUrl: "./generate-from-document-or-prompt-modal.component.html",
  styleUrl: "./generate-from-document-or-prompt-modal.component.scss",
})
export class GenerateFromDocumentOrPromptModalComponent {
  public active: number = 1;

  @Input() generationService: IGenerationService;
  @Input() showOptions: boolean;
  @Input() title: string;
  @Input() submitButtonTitle: string;

  @ViewChild("fromDocumentForm")
  fromDocumentForm!: FromDocumentFormComponent;
  @ViewChild("fromScratchForm")
  fromScratchForm!: FromScratchFormComponent;

  options = [
    { id: 1, name: "Option for template type selector (AI template generation modal) - Signature Request", value: "regular" },
    { id: 2, name: "Option for template type selector (AI template generation modal) - Internal Document", value: "template_document" },
  ];
  selectedOption = this.options[0];

  constructor(
    public modalService: NgbActiveModal,
    protected translocoService: TranslocoService,
  ) {}

  submitForm() {
    if (this.active === 1) {
      return this.fromDocumentForm?.submitForm();
    }
    if (this.active === 2) {
      return this.fromScratchForm?.submitForm();
    }
  }

  generateFromDocument(event: FromDocumentFormResult) {
    if (event.success) {
      this.generationService.generateFromDocument(
        event.data.file,
        event.data.prompt,
        this.selectedOption,
      );
      this.modalService.close();
    }
  }

  generateFromScratch(event: FromScratchFormResult) {
    if (event.success) {
      this.generationService.generateFromScratch(
        event.data.prompt,
        this.selectedOption,
      );
      this.modalService.close();
    }
  }

  get modalInfo(): string {
    if (this.active === 1) {
      return this.translocoService.translate(
        "Modal info (AI document generation modal) - from document modal info",
      );
    } else if (this.active === 2) {
      return this.translocoService.translate(
        "Modal info (AI document generation modal) - from prompt modal info",
      );
    }
    return "";
  }

  get isFormValid(): boolean {
    if (this.active === 1) {
      return !!this.fromDocumentForm?.isFormValid;
    }
    if (this.active === 2) {
      return !!this.fromScratchForm?.isFormValid;
    }
    return false;
  }
}
